import React, { useEffect, useState } from "react";
import backgroundImg from "../../assets/背景图.png";
import windowPng from "../../assets/windows.png";
import macPng from "../../assets//macos.png";
import uosPng from "../../assets/uos.png";
import downloadPng from "../../assets/下载.png";
import "./styles.css";
import dayjs from "dayjs";

type TDeviceInfo = {
  addr: string;
  updatedAt: number;
  version: string;
};

type TWebsiteInfo = {
  macTeacherInfo: TDeviceInfo;
  pcTeacherInfo: TDeviceInfo;
  uosTeacherInfo: TDeviceInfo;
};

type IProps = { rongkeTag: boolean };

export const DownloadContent: React.FC<IProps> = (props) => {
  const { rongkeTag } = props;
  const [downloadWindows, setDownloadWindows] = useState(false);
  const [downloadMac, setDownloadMac] = useState(false);
  const [downloadUos, setDownloadUos] = useState(false);
  const [websiteInfo, setWebsiteInfo] = useState<TWebsiteInfo>();

  const getInfo = async () => {
    try {
      var dhostValue = window.env?.dhost || "rongke.plaso.com";
      var customJSONUrl =
        "//" + dhostValue + "/school/manage/nc/innerCommon/getAppDownloadAddr";
      const response = await fetch(customJSONUrl);
      const data = await response.json();
      if (!data.code) {
        setWebsiteInfo(data.obj);
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
    } catch (error) {}
  };

  function handleDownload(href: string) {
    const link = document.createElement("a");
    link.href = href;
    link.click();
  }

  useEffect(() => {
    getInfo();
  }, []);

  function toHardwareRequirements(
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) {
    e.stopPropagation();
    if (window.env?.platform === "ecloud") {
      window.open(
        "https://rongke-plaso.feishu.cn/wiki/JWVuwuK5vitMa1kn8nvcZZaZnzf"
      );
    } else {
      window.open(
        "https://rongke-plaso.feishu.cn/wiki/R9Xiw43tOiJrdKkXP5icXchundf"
      );
    }
  }
  return (
    <div className="rootContent">
      <div className="banner">
        <div className="bannerbackground">
          <img src={backgroundImg} />
        </div>
        <div className="bannercontent content">
          <div className="bannertitle">
            {rongkeTag
              ? "数字化全场景教学教研解决方案"
              : "AI赋能智慧研训一体化平台"}
          </div>
          <div className="bannersubtitle">
            数字化教研空间 · 数字化备课空间 · 数字化教学空间
          </div>
          <div className="downloadContent">
            <div
              className="downloadItem"
              onMouseEnter={() => setDownloadWindows(true)}
              onMouseLeave={() => setDownloadWindows(false)}
              onClick={() => {
                handleDownload(websiteInfo?.pcTeacherInfo.addr as string);
              }}
            >
              <img
                src={downloadWindows ? downloadPng : windowPng}
                className="downloadLogo"
              />
              <div className="systemName">
                {downloadWindows ? "点击下载 Windows 客户端" : "Windows"}
              </div>
              <div className="downloadDes">
                <span>支持Win10及以上，RAM 8G及以上</span>
                <span
                  className="hardwareRequirements"
                  onClick={toHardwareRequirements}
                >
                  硬件配置要求
                </span>
              </div>
              <span className="versionInfo">
                {`更新：${dayjs(websiteInfo?.pcTeacherInfo.updatedAt).format(
                  "YYYY/MM/DD"
                )} 版本：${websiteInfo?.pcTeacherInfo.version || ""}`}
              </span>
            </div>
            <div
              className="downloadItem"
              onMouseEnter={() => setDownloadMac(true)}
              onMouseLeave={() => setDownloadMac(false)}
              onClick={() => {
                handleDownload(websiteInfo?.macTeacherInfo.addr as string);
              }}
            >
              <img
                src={downloadMac ? downloadPng : macPng}
                className="downloadLogo"
              />
              <div className="systemName">
                {" "}
                {downloadMac ? "点击下载 macOS 客户端" : "macOS"}
              </div>
              <div className="downloadDes">
                <span>支持macOS 12.0及以上，RAM 8G及以上</span>
                <span
                  className="hardwareRequirements"
                  onClick={toHardwareRequirements}
                >
                  硬件配置要求
                </span>
              </div>
              <span className="versionInfo">
                {`更新：${dayjs(websiteInfo?.macTeacherInfo.updatedAt).format(
                  "YYYY/MM/DD"
                )} 版本：${websiteInfo?.macTeacherInfo.version || ""}`}
              </span>
            </div>
            <div
              className="downloadItem"
              onMouseEnter={() => setDownloadUos(true)}
              onMouseLeave={() => setDownloadUos(false)}
              onClick={() => {
                handleDownload(websiteInfo?.uosTeacherInfo.addr as string);
              }}
            >
              <img
                src={downloadUos ? downloadPng : uosPng}
                className="downloadLogo"
              />
              <div className="systemName">
                {downloadUos ? "点击下载 统信UOS 客户端" : "统信UOS"}
              </div>
              <div className="downloadDes">
                <span>支持海光3000系列及以上</span>
                <span
                  className="hardwareRequirements"
                  onClick={toHardwareRequirements}
                >
                  硬件配置要求
                </span>
              </div>
              <span className="versionInfo">
                {`更新：${dayjs(websiteInfo?.uosTeacherInfo.updatedAt).format(
                  "YYYY/MM/DD"
                )} 版本：${websiteInfo?.uosTeacherInfo.version || ""}`}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
